var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-input-storage"
  }, _vm._l(_vm.storagesName, function (item, index) {
    return _c('progress-input-auto-increment', {
      key: index,
      attrs: {
        "index": index,
        "length": _vm.storagesName.length,
        "placeholder": _vm.placeholder
      },
      on: {
        "update": _vm.updateStorage,
        "clickDelete": _vm.clickDeleteStorage
      },
      model: {
        value: _vm.storagesName[index],
        callback: function ($$v) {
          _vm.$set(_vm.storagesName, index, $$v);
        },
        expression: "storagesName[index]"
      }
    });
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }